import { Grid } from "@mui/system";
import { Typography } from "@mui/material";

import GapsBetweenPlayersPerformanceTable, {
  PLAYERS_VS_DAILY_FTD_COLUMNS,
} from "./GapsBetweenPlayersPerformanceTable";
import { useSelector } from "react-redux";
import { useMemo, useState } from "react";
import { exportRowsToCsv } from "../Utils/anomaliesColumns";
import BrandSearchBar from "../Utils/BrandSearchBar";

const GapsBetweenPlayersPerformance = () => {
  const [choosenBrand, setChosenBrand] = useState<string | null>(null);

  const playersAndDailyPerformance = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.playersAndDailyPerformance,
  );

  const playersAndDailyPerformanceMetadata = useSelector(
    (state: any) =>
      state.bizDevelopmentAnomalies.playersAndDailyPerformanceMetadata,
  );

  // Shared with the other Brand-tab table (withoutFtdAndNetRevBrandData) —
  // there's no dedicated fetched-flag for this table alone.
  const isFetchedForBrandData = useSelector(
    (state: any) => state.bizDevelopmentAnomalies.isFetchedForBrandData,
  );

  //-- Extract unique brand names for Autocomplete filter
  const brandNames = useMemo(() => {
    const set = new Set<string>();
    (playersAndDailyPerformance || []).forEach((r: any) => {
      if (typeof r?.brand_name === "string") set.add(r.brand_name.trim());
    });
    return Array.from(set);
  }, [playersAndDailyPerformance]);

  // filter rows by the chosen brand
  const filteredData = useMemo(() => {
    const search = (choosenBrand ?? "").trim().toLowerCase();
    if (!search) return playersAndDailyPerformance;
    return playersAndDailyPerformance.filter((row: any) =>
      String(row.brand_name ?? "")
        .toLowerCase()
        .includes(search),
    );
  }, [playersAndDailyPerformance, choosenBrand]);

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        px={2}
        py={1.5}
        sx={{ borderTop: "1px solid #0000001F" }}
      >
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Gaps Between Players And Daily Performance
          </Typography>
        </Grid>
        <Grid size={4}>
          <BrandSearchBar
            dataTrackerForSearch="881"
            brandNames={brandNames}
            chosenBrand={choosenBrand}
            onBrandChange={setChosenBrand}
            dataTrackerForDownload="879"
            onDownload={() =>
              exportRowsToCsv(
                filteredData,
                PLAYERS_VS_DAILY_FTD_COLUMNS,
                "gaps-between-players-performance.csv",
              )
            }
            disabled={
              playersAndDailyPerformance.length === 0 || !isFetchedForBrandData
            }
          />
        </Grid>
      </Grid>
      <GapsBetweenPlayersPerformanceTable
        metadata={playersAndDailyPerformanceMetadata}
        rows={filteredData}
      />
    </>
  );
};

export default GapsBetweenPlayersPerformance;
